import React from "react";

export default function DocentesForm({
  modo = "crear",
  form = {},
  setForm = () => {},
  onSubmit = () => {},
  loading = false,
  formId = "docentes-form",
  showActions = true,
  onCancel,
}) {
  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const isValid = form.nombres?.trim() && form.apellidos?.trim() && form.documento?.trim();
  const handleCancel = () => {
    if (onCancel) {
      onCancel();
      return;
    }
    setForm({
      nombres: "",
      apellidos: "",
      documento: "",
      email: "",
      telefono: "",
      activo: true,
    });
  };

  return (
    <form id={formId} onSubmit={onSubmit} className="docentes-form">
      <div className="row g-3">
        <div className="col-12 col-md-6">
          <label htmlFor="nombres" className="form-label fw-semibold">
            Nombres
            <span className="text-danger ms-1">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="nombres"
            placeholder="Ej: Juan Carlos"
            value={form.nombres || ""}
            onChange={(e) => handleChange("nombres", e.target.value.toUpperCase())}
            maxLength="100"
            disabled={loading}
            required
          />
        </div>

        <div className="col-12 col-md-6">
          <label htmlFor="apellidos" className="form-label fw-semibold">
            Apellidos
            <span className="text-danger ms-1">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="apellidos"
            placeholder="Ej: García López"
            value={form.apellidos || ""}
            onChange={(e) => handleChange("apellidos", e.target.value.toUpperCase())}
            maxLength="100"
            disabled={loading}
            required
          />
        </div>

        <div className="col-12 col-md-4">
          <label htmlFor="documento" className="form-label fw-semibold">
            Documento
            <span className="text-danger ms-1">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="documento"
            placeholder="Ej: 1234567890"
            value={form.documento || ""}
            onChange={(e) => handleChange("documento", e.target.value)}
            maxLength="20"
            disabled={loading}
            required
          />
          <small className="text-muted d-block mt-1">Cédula o documento</small>
        </div>

        <div className="col-12 col-md-4">
          <label htmlFor="email" className="form-label fw-semibold">
            Email <span className="text-muted">(Opcional)</span>
          </label>
          <input
            type="email"
            className="form-control"
            id="email"
            placeholder="docente@ejemplo.com"
            value={form.email || ""}
            onChange={(e) => handleChange("email", e.target.value)}
            maxLength="100"
            disabled={loading}
          />
        </div>

        <div className="col-12 col-md-4">
          <label htmlFor="telefono" className="form-label fw-semibold">
            Teléfono <span className="text-muted">(Opcional)</span>
          </label>
          <input
            type="tel"
            className="form-control"
            id="telefono"
            placeholder="Ej: 0991234567"
            value={form.telefono || ""}
            onChange={(e) => handleChange("telefono", e.target.value)}
            maxLength="20"
            disabled={loading}
          />
        </div>

        <div className="col-12">
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              id="activo"
              checked={form.activo || false}
              onChange={(e) => handleChange("activo", e.target.checked)}
              disabled={loading}
            />
            <label className="form-check-label fw-semibold" htmlFor="activo">
              Docente activo
            </label>
          </div>
          <small className="text-muted d-block mt-1">
            Indica si el docente está disponible para asignaciones
          </small>
        </div>
      </div>

      {showActions && (
        <div className="d-flex gap-2 justify-content-end mt-4">
          <button
            type="button"
            className="btn btn-outline-secondary"
            disabled={loading}
            onClick={handleCancel}
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading || !isValid}
          >
            {loading && (
              <span className="spinner-border spinner-border-sm me-2" role="status" />
            )}
            {modo === "crear" ? "Crear docente" : "Actualizar docente"}
          </button>
        </div>
      )}
    </form>
  );
}
